import { isEmpty, isEqual } from "lodash";
import qs from "qs";

export const UNIVERSAL_TABLE_DEFAULT_PAGINATION = {
  current: 1,
  rowsPerPage: 20
};

export function buildUniversalTableUrlSettings({
  currentTabId,
  search,
  filters,
  sortBy,
  pagination
}) {
  let settingsToAppend = {
    currentTabId
  };

  if (!isEmpty(search)) {
    settingsToAppend = {
      ...settingsToAppend,
      search
    };
  }

  if (!isEmpty(filters)) {
    settingsToAppend = {
      ...settingsToAppend,
      filters
    };
  }

  if (pagination && !isEqual(pagination, UNIVERSAL_TABLE_DEFAULT_PAGINATION)) {
    settingsToAppend = {
      ...settingsToAppend,
      pagination
    };
  }

  if (sortBy && sortBy.field !== null) {
    settingsToAppend = {
      ...settingsToAppend,
      sortBy
    };
  }

  return settingsToAppend;
}

export function stringifyUniversalTableUrlSettings(tableState) {
  const query = qs.stringify(buildUniversalTableUrlSettings(tableState));
  return query ? `?${query}` : "";
}

/**
 *
 * @param {Object|null|undefined} initialSettings
 * @param {Object|null|undefined} settingsFromUrl
 * @returns {Object}
 */
export function mergeUniversalTableSeededSettings(
  initialSettings,
  settingsFromUrl
) {
  const initial = initialSettings || {};
  const fromUrl = settingsFromUrl || {};

  const hasFilters = !isEmpty(initial.filters) || !isEmpty(fromUrl.filters);
  const hasSearch = !isEmpty(initial.search) || !isEmpty(fromUrl.search);

  return {
    ...initial,
    ...fromUrl,
    ...(hasFilters
      ? {
          filters: {
            ...(initial.filters || {}),
            ...(fromUrl.filters || {})
          }
        }
      : {}),
    ...(hasSearch
      ? {
          search: {
            ...(initial.search || {}),
            ...(fromUrl.search || {})
          }
        }
      : {})
  };
}

/**
 * Normalize UniversalTable settings from a query string or a parsed params object
 * (e.g. web location.search or Expo useLocalSearchParams).
 *
 * @param {string|Object} input
 * @returns {Object}
 */
export function parseUniversalTableUrlSettings(input) {
  let settingsFromUrl =
    typeof input === "string"
      ? qs.parse(input, { ignoreQueryPrefix: true })
      : qs.parse(qs.stringify(input || {}), { ignoreQueryPrefix: true });

  if (
    settingsFromUrl.currentTabId != null &&
    settingsFromUrl.currentTabId !== ""
  ) {
    settingsFromUrl.currentTabId = Number(settingsFromUrl.currentTabId);
  }

  if (settingsFromUrl.pagination) {
    settingsFromUrl.pagination.current = Number(
      settingsFromUrl.pagination.current
    );
    settingsFromUrl.pagination.rowsPerPage = Number(
      settingsFromUrl.pagination.rowsPerPage
    );
  }

  if (!isEmpty(settingsFromUrl.filters)) {
    Object.keys(settingsFromUrl.filters).forEach(filterKey => {
      let filter = settingsFromUrl.filters[filterKey];

      if (!filter || typeof filter !== "object" || Array.isArray(filter)) {
        return;
      }

      ["min", "max"].forEach(key => {
        if (typeof filter[key] !== "undefined") {
          if (filter[key] === "") {
            filter[key] = null;
          } else if (!isNaN(filter[key])) {
            filter[key] = Number(filter[key]);
          }
        }
      });
    });
  }

  return settingsFromUrl;
}
